var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/gift_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.2458 29.1667H11.5792V52.5001C11.5792 61.2501 14.4958 64.1667 23.2458 64.1667H46.5792C55.3292 64.1667 58.2458 61.2501 58.2458 52.5001V29.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.075 29.1667V44.1584C26.075 46.4917 28.6417 47.8626 30.5958 46.6084L33.3375 44.8001C34.3292 44.1584 35.5833 44.1584 36.5458 44.8001L39.1417 46.5501C41.0667 47.8334 43.6625 46.4626 43.6625 44.1292V29.1667H26.075Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.7083 20.4166V23.3333C62.7083 26.5416 61.1625 29.1666 56.875 29.1666H13.125C8.6625 29.1666 7.29166 26.5416 7.29166 23.3333V20.4166C7.29166 17.2083 8.6625 14.5833 13.125 14.5833H56.875C61.1625 14.5833 62.7083 17.2083 62.7083 20.4166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.95 14.5833H17.85C16.8583 13.5041 16.8875 11.8416 17.9375 10.7916L22.0792 6.64995C23.1583 5.57078 24.9375 5.57078 26.0167 6.64995L33.95 14.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.1208 14.5833H36.0208L43.9542 6.64995C45.0333 5.57078 46.8125 5.57078 47.8917 6.64995L52.0333 10.7916C53.0833 11.8416 53.1125 13.5041 52.1208 14.5833Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2a024761b340b67df59ad2b03a8988b9.svg";
export { ForwardRef as ReactComponent };